export function Search() {
  // const { setOpen } = useSearch()
  return null
}
